import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { Toaster } from "@/components/ui/sonner";
import LandingPage from "@/pages/LandingPage";
import AuthPage from "@/pages/AuthPage";
import Dashboard from "@/pages/Dashboard";
import Studio from "@/pages/Studio";
import Pricing from "@/pages/Pricing";
import PaymentSuccess from "@/pages/PaymentSuccess";
import AdminUsage from "@/pages/AdminUsage";
import AdminCredits from "@/pages/AdminCredits";
import VerifyEmail from "@/pages/VerifyEmail";
import AccountSettings from "@/pages/AccountSettings";
import ForgotPassword from "@/pages/ForgotPassword";
import ResetPassword from "@/pages/ResetPassword";
import { RenderNotifier } from "@/components/RenderNotifier";

const Protected = ({ children }) => {
  const { user } = useAuth();
  if (user === null)
    return (
      <div className="min-h-screen flex items-center justify-center bg-background">
        <div className="w-10 h-10 rounded-full border-2 border-[#00E5FF] border-t-transparent animate-spin" />
      </div>
    );
  if (!user) return <Navigate to="/login" replace />;
  return children;
};

function App() {
  return (
    <div className="App grain">
      <AuthProvider>
        <BrowserRouter>
          <RenderNotifier />
          <Routes>
            <Route path="/" element={<LandingPage />} />
            <Route path="/login" element={<AuthPage mode="login" />} />
            <Route path="/register" element={<AuthPage mode="register" />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/reset-password" element={<ResetPassword />} />
            <Route path="/dashboard" element={<Protected><Dashboard /></Protected>} />
            <Route path="/studio/:id" element={<Protected><Studio /></Protected>} />
            <Route path="/pricing" element={<Protected><Pricing /></Protected>} />
            <Route path="/admin/usage" element={<Protected><AdminUsage /></Protected>} />
            <Route path="/admin/credits" element={<Protected><AdminCredits /></Protected>} />
            <Route path="/verify-email" element={<VerifyEmail />} />
            <Route path="/account" element={<Protected><AccountSettings /></Protected>} />
            <Route path="/payment/success" element={<Protected><PaymentSuccess /></Protected>} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
        <Toaster position="top-right" theme="dark" />
      </AuthProvider>
    </div>
  );
}

export default App;
